<template>
  <el-dialog
    :title="'修改密码'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    @closed="closeDialog"
    width="400px"
  >
    <div class="bg_all">
      <div class="mimcz">
        <ul>
          <li>
            <span>原来密码:</span
            ><input type="password" class="iptxs" v-model="pwdBean.oldPwd" />
          </li>
          <li>
            <span>新的密码:</span
            ><input type="password" class="iptxs" v-model="pwdBean.loginPwd" />
          </li>
          <li>
            <span>确认新密码:</span
            ><input type="password" class="iptxs" v-model="loginPwd2" />
          </li>
          <a class="xmim" href="javascript:void(0);" @click="updPwd"
            >修改密码</a
          >
        </ul>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { updPwd } from "@/api/login";
export default {
  data() {
    return {
      visible: false,
      pwdBean: {
        token: "",
        oldPwd: "",
        loginPwd: ""
      },
      loginPwd2: ""
    };
  },
  created() {
    if (this.token === "") {
      this.$router.push("/login");
    } else {
      this.initData();
    }
  },
  computed: {
    token() {
      return this.getToken();
    }
  },
  methods: {
    initData() {
      this.visible = true;
      this.pwdBean.token = this.token;
    },
    // 关闭弹出层
    closeDialog() {
      this.visible = false;
    },
    updPwd() {
      if (this.pwdBean.oldPwd === "") {
        this.$message.error("请输入旧密码。");
        return;
      }
      if (this.pwdBean.loginPwd === "") {
        this.$message.error("请输入新密码。");
        return;
      }
      if (this.pwdBean.loginPwd != this.loginPwd2) {
        this.$message.error("新密码与确认密码不一致");
        return;
      }
      this.pwdBean.token = this.token;
      updPwd(this.pwdBean).then(res => {
        if (res.code === 200) {
          this.$message.success(res.msg);
          this.visible = false;
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
}
</script>
<style>
.el-dialog__body {
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 30px;
  padding-top: 0px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
}
</style>
